
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.497 5.472c.317.301.487.63.502.986.018.362-.185.742-.61 1.146l-7.161 6.82a.713.713 0 01-.093.08c-.02.028-.043.041-.064.06-.096.08-.196.155-.301.223-.005.005-.01 0-.01.01-.102.06-.2.106-.296.134a1.169 1.169 0 01-.292.064C8.128 15 8.08 15 8.03 15c-.271-.01-.533-.1-.754-.255a.252.252 0 01-.064-.041c-.064-.033-.116-.084-.17-.135a.457.457 0 01-.078-.065L3.613 11.31c-.422-.403-.627-.782-.612-1.14.015-.357.18-.68.495-.982.318-.3.663-.464 1.042-.482.375-.013.775.181 1.197.585l2.32 2.21 6.215-5.917c.423-.402.82-.598 1.196-.583.37.009.716.17 1.032.47l-.001.001z"}})])
          )
        }
      }
    